import React, {useEffect, useState} from "react";
import {Button, Image, Popover, Tooltip} from "antd";
import {FilePreview, getFileTypeInfo} from "./FilePreview";
import {DownloadOutlined, EyeOutlined} from "@ant-design/icons";
import {FiPaperclip} from "react-icons/fi";

export const FileAttachments = ({attachments}) => {
    const [previewImages, setPreviewImages] = useState([]);
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewIndex, setPreviewIndex] = useState(0);
    const [popoverOpen, setPopoverOpen] = useState(false);

    // Create image list for preview on component mount
    useEffect(() => {
        const images = attachments
            .filter(att => att.file_type.startsWith('image/'))
            .map(att => ({
                src: `/storage/${att.file_path}`,
                title: att.original_name
            }));
        setPreviewImages(images);
    }, [attachments]);

    const handlePreview = async (attachment) => {
        if (attachment.file_type.startsWith('image/')) {
            const index = previewImages.findIndex(img => img.src === `/storage/${attachment.file_path}`);
            setPreviewIndex(index);
            setPreviewOpen(true);
            setPopoverOpen(false); // Close popover when preview opens
        }
    };


    return (
        <>
            <Popover
                open={popoverOpen}
                onOpenChange={setPopoverOpen}
                trigger={["click"]}
                content={
                    <div className="max-w-[400px] p-4">
                        <div className="flex justify-between items-center mb-4">
                            <span className="text-sm font-medium">
                                Attachments ({attachments.length})
                            </span>
                        </div>

                        <div className={`grid ${attachments.length === 1 ? '' : 'grid-cols-2'} gap-4`}>
                            {attachments.map((attachment) => {
                                const {color, icon, type, previewable} = getFileTypeInfo(
                                    attachment.file_type,
                                    attachment.original_name
                                );

                                return (
                                    <div
                                        key={attachment.id}
                                        className={`relative group bg-gray-50 rounded-lg overflow-hidden hover:bg-gray-100 transition-all ${
                                            attachments.length === 1 ? 'w-full' : ''
                                        }`}
                                    >
                                        {previewable ? (
                                            <FilePreview attachment={attachment}/>
                                        ) : (
                                            <div className="p-4 flex flex-col items-center justify-center h-[100px]">
                        <span className={`${color} mb-2`}>
                            {icon}
                        </span>
                                                <Tooltip title={attachment.original_name}>
                            <span className="text-xs text-center truncate w-full px-2">
                                {attachment.original_name}
                            </span>
                                                </Tooltip>
                                            </div>
                                        )}

                                        {/* Download button overlay */}
                                        <div
                                            className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                                            <div className="flex space-x-2">
                                                {previewable && (
                                                    <Button
                                                        type="text"
                                                        icon={<EyeOutlined className="text-white"/>}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handlePreview(attachment);
                                                        }}
                                                    />
                                                )}
                                                <Button
                                                    type="text"
                                                    icon={<DownloadOutlined className="text-white"/>}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        const link = document.createElement('a');
                                                        link.href = `/storage/${attachment.file_path}`;
                                                        link.download = attachment.original_name;
                                                        link.click();
                                                        setPopoverOpen(false); // Close popover when downloading
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                }
                title={null}
                className="relative inline-block text-left"
            >
                <Button
                    type="text"
                    className="flex items-center space-x-1 text-xs hover:bg-gray-100 rounded-md"
                >
                    <FiPaperclip className="h-3.5 w-3.5"/>
                    <span>{attachments.length}</span>
                </Button>
            </Popover>

            {/* Image Preview */}
            <div style={{display: 'none'}}>
                <Image.PreviewGroup
                    preview={{
                        visible: previewOpen,
                        current: previewIndex,
                        onVisibleChange: (vis) => setPreviewOpen(vis),
                        images: previewImages,
                    }}
                >
                    {previewImages.map((image, index) => (
                        <Image key={index} src={image.src}/>
                    ))}
                </Image.PreviewGroup>
            </div>
        </>
    );
};
